export default [
    {
      id: "email_otp",
      title: "Activation Number",
      placeholder: "Enter Activation Number Provided Through Email",
      type: "number",
      email: false,
      required: true,
      maxLength: 6,
    }
  ];
  